export default "__VITE_ASSET__548bb6b2__"